import { render, staticRenderFns } from "./heading1.vue?vue&type=template&id=1e6cad17&"
import script from "./heading1.vue?vue&type=script&lang=js&"
export * from "./heading1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports